export default class Locale_RootSettingsEditor { 
	FailedSavingSettings: string = "Failed saving settings!";
	SettingsSaved: string = "Settings saved! You might need to refresh the page, depending on which settings you've changed..";
}